import { render, staticRenderFns } from "./AlarmCombi.vue?vue&type=template&id=42df6f50"
import script from "./AlarmCombi.vue?vue&type=script&lang=js"
export * from "./AlarmCombi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports